module.exports = __webpack_public_path__ + "static/media/banks.4674d536.svg";